
export class PlanningCable {
  cableGridelementId: number;
  lengthKm: number;
  cabletypeId: number;
  cabletype: string;
  startNode: String;
  endNode: String;
}
